import React, { SetStateAction } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../redux/rootReducer';
import { removeExistingAvailability } from '../../../../redux/availability/actions/availability.action';
import iconClose from '../../../../images/icon-close.svg';
import styles from './DeleteAvailabilityModal.module.css';
import TextInput from '../../../common/input/textInput/TextInput';

interface DeleteAvailabilityModalProps {
    setOpen: React.Dispatch<SetStateAction<boolean>>;
    setIsLoading: React.Dispatch<SetStateAction<boolean>>;
    availabilityId: string;
    locationId: string;
}

const DeleteAvailabilityModal = ({ setIsLoading, setOpen, availabilityId, locationId }: DeleteAvailabilityModalProps) => {
    const dispatch: AppDispatch = useDispatch();

    const { control, handleSubmit, watch } = useForm({
        defaultValues: {
            reason: '',
        },
    });

    const reason = watch('reason');

    const removeAvailabilityHandler = async () => {
        if (!availabilityId || !locationId || !reason || reason.trim() === '') return;
        setIsLoading(true);
        await dispatch(removeExistingAvailability(availabilityId, locationId, reason));
        setIsLoading(false);
        await setOpen(false);
    };

    const closeModal = () => setOpen(false);

    return (
        <div className={styles.modalRemoveStaff}>
            <form onSubmit={handleSubmit(removeAvailabilityHandler)}>
                <div className={styles.modalHeader}>
                    <div className={styles.modalTitle}>Delete Availability</div>
                    <span className={styles.close}>
                        <img src={iconClose} onClick={closeModal} alt="Close" />
                    </span>
                </div>

                <div className={styles.modalBody}>
                    <div>
                        <h2 className={styles.modalBodyTitle}>Are you sure you want to delete this availability?</h2>
                        <p className={styles.modalBodyInfo}>Availability cannot be recovered once deleted.</p>
                    </div>

                    <div className={styles.reasonInput}>
                        <Controller
                            name="reason"
                            control={control}
                            render={({ field }) => (
                                <TextInput
                                    {...field}
                                    autoFocus
                                    type="text"
                                    id="reason"
                                    placeholder="Enter reason for deleting this availability"
                                />
                            )}
                        />
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button onClick={closeModal} className={`${styles.Modalbtn} ${styles.cancelBtn}`}>
                        Cancel
                    </button>
                    <button type="submit" disabled={!(reason && reason.trim() !== '')} className={`${styles.Modalbtn} ${styles.deleteBtn}`}>
                        Delete
                    </button>
                </div>
            </form>
        </div>
    );
};

export default DeleteAvailabilityModal;
